import PropTypes from "prop-types";
import CalculatorInput from "./CalculatorInput";
import { CREATININE_UNITS } from "../../utils/calculators/constants";

const CreatinineInputGroup = ({
  label = "Serum creatinine",
  idPrefix = "calc",
  creatinineValue,
  creatinineUnit,
  onCreatinineChange,
  onCreatinineUnitChange,
  error,
  unitOptions = CREATININE_UNITS,
  inputProps = {},
  isWebLayout = false,
  "data-testid": dataTestId = "creatinine-input",
  ...rest
}) => {
  const defaultInputProps = {
    type: "number",
    min: 0,
    autoComplete: "off",
    "data-testid": dataTestId,
    inputMode: "decimal",
    ...inputProps,
  };

  return (
    <CalculatorInput
      label={label}
      id={`${idPrefix}-creatinine`}
      value={creatinineValue}
      onChange={onCreatinineChange}
      error={error}
      unitOptions={unitOptions}
      unitValue={creatinineUnit}
      onUnitChange={onCreatinineUnitChange}
      inputProps={defaultInputProps}
      isWebLayout={isWebLayout}
      {...rest}
    />
  );
};

CreatinineInputGroup.propTypes = {
  label: PropTypes.string,
  idPrefix: PropTypes.string,
  creatinineValue: PropTypes.string.isRequired,
  creatinineUnit: PropTypes.string.isRequired,
  onCreatinineChange: PropTypes.func.isRequired,
  onCreatinineUnitChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  unitOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      shortLabel: PropTypes.string,
    }),
  ),
  inputProps: PropTypes.object,
  isWebLayout: PropTypes.bool,
  "data-testid": PropTypes.string,
};

export default CreatinineInputGroup;
